<template>
  <div id="navigation" class="inline center" :class="$mq">
    <div v-for="(item, index) in steps" :key="index" class="inline center">
      <router-link :to="{ path: item, query: $route.query }" class="step" :class="status(index)">
        <SvgIcon :icon="`step-${item}`" class="icon" fill />
      </router-link>
      <div class="separator" v-if="item !== 'contact'"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      steps: ["energy", "consumption", "calculation", "contact"]
    };
  },
  methods: {
    status(index) {
      let status = "";

      if (this.$route.name) {
        if (
          index < this.steps.indexOf(this.$route.name.toLowerCase()) ||
          this.$route.name === "Comparison" ||
          this.$route.name === "Simulation"
        )
          status = "done";
        if (index === this.steps.indexOf(this.$route.name.toLowerCase()))
          status = "active";
      }

      return status;
    }
  }
};
</script>

<style lang="scss" scoped>
#navigation {
  margin: 30px 0;

  .step {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 2.8rem;
    border: 1px solid #fdcb47;
    // background: #4d545a;
    color: #fdcb47;

    &.done,
    &.active {
      color: black;
      background: #fdcb47;
    }

    &.done + .separator {
      border: 1.5px solid #fdcb47;
    }
  }

  .separator {
    border: 1.5px solid rgb(255, 217, 146);
    width: 30px;
  }

  &.mobile {
    .step {
      height: 50px;
      width: 50px;
      font-size: 1.8rem;
    }

    .separator {
      width: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue